// ─────────────────────────────────────────────────────────────────────────────
// Environment Configuration
//
// All API endpoints derive from a single base URL injected at build time
// via REACT_APP_API_URL.  This eliminates hardcoded API Gateway IDs and
// makes the frontend work with any environment (dev / staging / prod)
// deployed by the CDK stacks.
//
// For local development, set REACT_APP_API_URL in a .env.local file:
//   REACT_APP_API_URL=https://xxxxxxxxxx.execute-api.us-east-1.amazonaws.com/dev
// ─────────────────────────────────────────────────────────────────────────────

// The single source of truth for the API base URL
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Determine current environment label
function getCurrentEnvironment() {
  const envFromVar = process.env.REACT_APP_ENVIRONMENT;
  if (envFromVar) return envFromVar;

  const hostname = window.location.hostname;
  if (hostname.includes('staging')) return 'staging';
  if (hostname === 'travelflow.link' || hostname === 'www.travelflow.link') return 'prod';
  if (hostname === 'localhost') return 'dev';
  return 'dev';
}

export const ENVIRONMENT = getCurrentEnvironment();

// ── All API endpoints derived from the single base ──────────────────────────
export const API_BASE_URL            = API_BASE;
export const INVITE_CODE_API_BASE    = API_BASE;
export const FLIGHT_AWARE_API_BASE   = `${API_BASE}/flights`;
export const TRAFFIC_API_BASE        = `${API_BASE}/google-maps`;
export const PHONE_VERIFICATION_API_BASE = `${API_BASE}/phone-verification`;
export const USER_PREFERENCES_API_BASE   = `${API_BASE}/user-preferences`;
export const FLIGHT_MONITOR_API_BASE     = `${API_BASE}/flight-monitor`;
export const PARSE_BEDROCK_API_BASE      = `${API_BASE}/parse-bedrock`;
export const TRIP_EVENTS_API_BASE        = `${API_BASE}/trip-events`;
export const RESTAURANT_AI_API_BASE      = `${API_BASE}/restaurant-ai`;
export const HOTEL_AI_API_BASE           = `${API_BASE}/hotel-ai`;
export const AIRPORT_JOURNEY_API_BASE    = `${API_BASE}/airport-journey`;
export const AI_CHAT_API_BASE            = `${API_BASE}/ai-chat`;
export const TRANSPORTATION_API_BASE     = `${API_BASE}/transportation-instructions`;
export const TASTE_PROFILE_API_BASE      = `${API_BASE}/taste-profile`;
export const JOURNEY_PREFERENCES_API_BASE = `${API_BASE}/journey-preferences`;

// Uber API Configuration (for future use — key must be set via env var)
export const UBER_ACCESS_KEY = process.env.REACT_APP_UBER_ACCESS_KEY || '';

// Config object for backward compatibility
export const CONFIG = {
  name: ENVIRONMENT,
  region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
  apiGatewayBaseUrl: API_BASE,
};

// Environment info for debugging
export const ENV_INFO = {
  name: ENVIRONMENT,
  region: CONFIG.region,
  environment: ENVIRONMENT,
  apiBaseUrl: API_BASE,
};

export default CONFIG;
